import styled, { css } from 'styled-components'
import { SecondaryButton } from '@chegg-ui/button'
import { colors, spacing } from '@chegg-ui/theme'
import { SpecialOutline } from '@chegg-wt/core/theme/fanta/button'
import { adjust, themeBreakPoints } from '@chegg-wt/core/theme/theme'
import FantaTheme from '@chegg-wt/core/theme/fanta/theme'
import { AspiraStack } from '@chegg-wt/core/theme/fanta/fonts'

/**
 * [1]: We're going to have positioned items in our checkbox menu, make sure they're TRBL are relative to `Menu`
 */
export const Menu = styled.div<{ isPremium: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 60px;
  border: 1px solid ${({ theme }) => theme.Colors.forInterface.interfaceColor12};
  box-shadow: 0 -2px 4px 0 rgba(187, 187, 187, 0.3);
  width: 100%;
  justify-content: space-between;
  background-color: ${({ theme }) => theme.Colors.forInterface.interfaceColor11};
  ${AspiraStack};
  /* this is to make sure ads show correctly on non pro */
  ${({ isPremium }) =>
    isPremium
      ? css`
          position: fixed;
          bottom: 0;
          z-index: 999;
        `
      : css`
          position: relative;
        `};
`

export const NumberSelected = styled.div`
  color: ${colors.grey};
  width: 80px;
  text-align: center;
  margin-left: 8px; /* the checkbox has styles that push the margin by 8px and we want 16px */
`

export const SelectAll = styled(SecondaryButton)`
  margin-left: ${FantaTheme.spacing.fanta.xxs};
  font-size: ${FantaTheme.font.text.size.md};
  padding: ${FantaTheme.spacing.fanta.md} ${FantaTheme.spacing.fanta.xxs};
`

export const StatusContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`

export const CheckboxWrap = styled.div`
  display: inline-block;
  vertical-align: middle;
  margin-left: ${FantaTheme.spacing.fanta.lg};
`

export const OrangeDash = styled.div`
  height: 4px;
  width: 10px;
  border-radius: 1.5px;
  background-color: ${({ theme }) => theme.colors.orange};
  top: 27px;
  left: 28px;
  position: absolute;
  pointer-events: none;
`

export const ActionButtonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: ${FantaTheme.spacing.fanta.lg};
`

export const ActionButton = styled(SecondaryButton).attrs({
  variant: 'outlined',
  size: 'small',
})`
  ${SpecialOutline}
  margin-left: ${spacing.px12};
  && {
    box-shadow: none;
  }
  &&:hover {
    box-shadow: none;
  }
`

export const menuButtonHeight = '30px'

export const MenuButton = styled.button`
  height: ${menuButtonHeight};
  width: 30px;
  border: 2px solid ${({ theme }) => theme.Colors.forInterface.interfaceColor14};
  border-radius: 6px;
  padding: 0;
  margin: 0 16px;
  background-color: inherit;
  svg {
    margin: 2px 0;
  }
`

/**
 * [1]: This keeps MenuItemWrapper stuck right above, and slightly right of the `Menu`
 * [2]: This is an "average scrollbar width" value, a better way of getting this value would be at runtime...
 * [3]: Operating assumption is that the menu button will always be positioned in the vertical middle of the Menu
 */
export const MenuItemWrapper = styled.div`
  border: 1px solid ${({ theme }) => theme.Colors.forInterface.interfaceColor21};
  border-radius: 4px;
  background-color: ${({ theme }) => theme.Colors.forInterface.interfaceColor11};
  box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.05);
  z-index: 100;

  position: absolute; /* [1] */
  right: 17px; /* [1][2] */
  bottom: calc(50% + (${menuButtonHeight} / 2)); /* [1][3] */
`

export const MenuItem = styled.button`
  background: inherit;
  width: 100%;
  display: flex;
  border-bottom: 0.5px solid ${({ theme }) => theme.Colors.forInterface.interfaceColor21};
  height: 50px;
  align-items: center;
  ${AspiraStack};
  padding: 0 24px;
  cursor: pointer;
  &:hover {
    background-color: ${colors.greyXlight};
  }
`

/**
 * [1]: Eyeballed value
 * TODO: reevaluate the need to do this once we've gotten rid of the bootstrap-y breakpoints
 */
export const DesktopContainer = styled.div`
  @media (max-width: ${({ theme }) => adjust(themeBreakPoints.small(theme), 50)}) {
    /* [1] */
    display: none;
  }
`
export const MobileContainer = styled.div`
  @media (min-width: ${({ theme }) => adjust(themeBreakPoints.small(theme), 51)}) {
    /* [1] */
    display: none;
  }
`
